import { frontendCommitHash } from '@/config';
import { backendGitCommitAtom } from '@hooks/useApp';
import { Box, Link, Skeleton } from '@mui/material';
import { useAtomValue } from 'jotai';

const FRONTEND_COMMIT_HASH_SHORT = frontendCommitHash.substring(0, 7);
const FRONTEND_COMMIT_URL = `https://bitbucket.org/australian_greens/listmanager-frontend/commits/${frontendCommitHash}`;

const BACKEND_COMMIT_BASE_URL =
  'https://bitbucket.org/australian_greens/listmanager-backend/commits';

// const gitCommitDisplayDefaultProps = {};

type GitCommitDisplayProps = {
  wide: boolean;
};

const GitCommitDisplay = ({ wide }: GitCommitDisplayProps) => {
  const backendGitCommit = useAtomValue(backendGitCommitAtom);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
      }}>
      <Box>
        {wide && <span>Frontend commit: </span>}
        <Link href={FRONTEND_COMMIT_URL} title="Frontend git commit">
          {FRONTEND_COMMIT_HASH_SHORT}
        </Link>
      </Box>
      <Box>
        {wide && <span>Backend commit: </span>}{' '}
        <>
          {backendGitCommit === '' && (
            <Skeleton sx={{ bgcolor: 'grey.900', display: 'inline-block' }} width={65} />
          )}
          {backendGitCommit !== '' && (
            <Link
              href={`${BACKEND_COMMIT_BASE_URL}/${backendGitCommit}`}
              title="Backend git commit"
            >
              {backendGitCommit.substring(0, 7)}
            </Link>
          )}
        </>
      </Box>
    </Box>
  );
};

export default GitCommitDisplay;
